module.exports = __webpack_public_path__ + "img/banner5.e20dc7b6.jpg";